import { pricingRuleIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const deletePricingRule = {
  name: "deletePricingRule" as const,

  input: z.object({ pricingRuleId: pricingRuleIdFormat.schema }),

  output: z.object({ success: z.boolean() }),
};
